var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.loading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_c('relatorio-retornou-origem-list-concluidos',{ref:"concluidos",attrs:{"headers":_vm.headers,"tela":_vm.permission},on:{"loading":function($event){_vm.loading = true},"loaded":function($event){_vm.loading = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }